import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative flex h-full flex-col" }
const _hoisted_2 = { class: "relative flex flex-1 flex-col" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "flex flex-1 flex-col break-words pt-4" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "text-12 font-normal opacity-50"
}
const _hoisted_7 = {
  key: 0,
  class: "pr-8 text-12 text-black-400"
}
const _hoisted_8 = { class: "text-14 font-medium" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["name", "value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["href", "disabled"]
const _hoisted_14 = ["href", "disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")
  const _component_v_video = _resolveComponent("v-video")
  const _component_splide_slide = _resolveComponent("splide-slide")
  const _component_splide_track = _resolveComponent("splide-track")
  const _component_grid_item_tags = _resolveComponent("grid-item-tags")
  const _component_splide = _resolveComponent("splide")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_splide, {
        ref: "splide",
        "has-track": false,
        options: {
          type: 'slide',
          arrows: false,
          pagination: true,
          mediaQuery: 'min',
          flickMaxPages: 1,
          flickPower: 50,
          gap: '0.1rem',
          classes: {
            page: 'splide__pagination__page w-6 h-6 mobile-xl:w-8 mobile-xl:h-8 rounded-full bg-black-900',
          },
        },
        "onSplide:pagination:updated": $options.handlePaginationUpdated,
        onMouseenterOnce: $options.slideToSecondMedia,
        onMouseoverOnce: $options.handleSliderMove,
        onTouchstartOnce: $options.handleSliderMove,
        onMouseleaveOnce: $options.slideToFirstMedia
      }, {
        default: _withCtx(() => [
          _createVNode(_component_splide_track, { class: "peer" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.productMedia, (media, i) => {
                return (_openBlock(), _createBlock(_component_splide_slide, {
                  key: media.id,
                  class: "w-full laptop:flex"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: $options.productUrl,
                      class: "group aspect-grid-item max-h-[40rem] w-full bg-black-200"
                    }, [
                      (i === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (media.media_type === 'image')
                              ? (_openBlock(), _createBlock(_component_v_image, {
                                  key: 0,
                                  lazyloaded: $props.lazyloadMedia,
                                  source: media.src,
                                  alt: $props.product.title,
                                  class: "h-full w-full object-cover object-top"
                                }, null, 8, ["lazyloaded", "source", "alt"]))
                              : (_openBlock(), _createBlock(_component_v_video, {
                                  key: 1,
                                  autoplay: "",
                                  lazyloaded: $props.lazyloadMedia,
                                  source: media.sources[0].url,
                                  "source-mobile": media.sources[0].url,
                                  class: "h-full w-full object-cover object-top"
                                }, null, 8, ["lazyloaded", "source", "source-mobile"]))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (media.media_type === 'image')
                              ? (_openBlock(), _createBlock(_component_v_image, {
                                  key: 0,
                                  lazyloaded: "",
                                  source: media.src,
                                  alt: $props.product.title,
                                  class: "aspect-grid-item max-h-[40rem] w-full object-cover object-top"
                                }, null, 8, ["source", "alt"]))
                              : (_openBlock(), _createBlock(_component_v_video, {
                                  key: 1,
                                  lazyloaded: "",
                                  autoplay: "",
                                  source: media.sources[0].url,
                                  "source-mobile": media.sources[0].url,
                                  class: "aspect-grid-item max-h-[40rem] w-full object-cover object-top",
                                  style: {"display":"none"}
                                }, null, 8, ["source", "source-mobile"]))
                          ], 64))
                    ], 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          ($props.product.tags)
            ? (_openBlock(), _createBlock(_component_grid_item_tags, {
                key: 0,
                product: {
            available: $props.product.available,
            title: $props.product.title,
            price: $props.product.price,
            compare_at_price: $props.product.compare_at_price,
            tags: $props.product.tags,
          },
                "collection-kit-discount-percentage": $options.discountPercentage
              }, null, 8, ["product", "collection-kit-discount-percentage"]))
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createElementVNode("ul", { class: "splide__pagination center-x absolute bottom-8 z-10 gap-8" }, null, -1))
        ]),
        _: 1,
        __: [3]
      }, 8, ["onSplide:pagination:updated", "onMouseenterOnce", "onMouseoverOnce", "onTouchstartOnce", "onMouseleaveOnce"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: $options.productUrl,
          class: "flex flex-col gap-4 text-16 font-medium",
          onClick: _cache[0] || (_cache[0] = $event => ($options.saveProductGridIndex($props.productIndex)))
        }, [
          _createTextVNode(_toDisplayString($props.product.title) + " ", 1),
          ($props.product.subheadline)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.product.subheadline), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_5),
        _createElementVNode("p", {
          class: _normalizeClass($options.backInStockEligible ? `mt-0` : `mt-auto`)
        }, [
          ($options.originPrice)
            ? (_openBlock(), _createElementBlock("del", _hoisted_7, _toDisplayString($options.originPrice), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_8, _toDisplayString($options.price), 1)
        ], 2)
      ]),
      ($data.isQuickAddEnabled && $options.productType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!$options.productType.includes('starter') && $options.productType !== 'gift cards')
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  name: "add_to_cart",
                  class: "mt-auto pt-12",
                  onSubmit: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.throttledQuickAdd($event)), ["prevent"]))
                }, [
                  ($options.backInStockEligible)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn-xsmall btn-accent btn-mail__before capitalize",
                        onClick: _cache[1] || (_cache[1] = $event => ($options.klaviyoRedirect()))
                      }, _toDisplayString($data.product_back_in_stock_signup_label), 1))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        name: "add",
                        class: "btn-xsmall btn-accent btn-plus__before capitalize",
                        disabled: !$props.product.available
                      }, _toDisplayString($data.locale.add_to_cart), 9, _hoisted_9)),
                  _createElementVNode("input", {
                    type: "hidden",
                    name: "id",
                    value: $props.product.first_available_variant_id
                  }, null, 8, _hoisted_10),
                  ($props.product?.deliverable_at)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 2,
                        type: "hidden",
                        name: `properties[${$data.locale.deliverable_at}]`,
                        value: $props.product.deliverable_at
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("input", {
                    type: "hidden",
                    name: "properties[_KitOptionalProductStandardPrice]",
                    value: $props.product.price
                  }, null, 8, _hoisted_12)
                ], 32))
              : ($options.productType.includes('starter'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: $options.productUrl,
                    class: "btn-xsmall btn-accent btn-arrow__before mt-auto self-start pt-12 text-center capitalize",
                    disabled: !$props.product.available
                  }, _toDisplayString($data.locale.create_new_set), 9, _hoisted_13))
                : ($options.productType === 'gift cards')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: $options.productUrl,
                      class: "btn-xsmall btn-accent btn-arrow__before mt-auto self-start pt-12 text-center capitalize",
                      disabled: !$props.product.available
                    }, _toDisplayString($data.locale.configure_gift_card), 9, _hoisted_14))
                  : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}